import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import React, {useState} from 'react';
import DeleteIcon from "@mui/icons-material/Delete"
import { SegnalazioneLight } from "../../../services/models/objs/SegnalazioneLight";


const customStylePrimary = {
    color: "#004D99",
    width: 30,
    height: 30,
};

export interface CustomDeleteIconButtonProps {
  title: string;
  modalTitle: string;
  modalBody: string;
  currentSegnalazione?: SegnalazioneLight;
  onCallBack: (submitted: boolean, currentSegnalazione?: SegnalazioneLight) => void;
}

const CustomDeleteIconButton = ({title, modalTitle, modalBody, onCallBack, currentSegnalazione}: CustomDeleteIconButtonProps) => {

    const [open, setOpen] = useState(false);
    // const handleClose = () => setOpen(false);

    const handleConfirm = () => {
      onCallBack(true, currentSegnalazione);
      setOpen(false)
    }

    const handleCancel = () => {
      onCallBack(false, undefined);
      setOpen(false)
    }


    return<div className="d-inline w-25">
        <IconButton aria-label="delete" style={customStylePrimary} title={title} onClick={() => setOpen(true)}>
            <DeleteIcon/>
        </IconButton>
        <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {modalTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {modalBody}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Annulla</Button>
          <Button onClick={handleConfirm} autoFocus>
            Continua
          </Button>
        </DialogActions>
      </Dialog>
    </div>
}

export default CustomDeleteIconButton;
